import React from "react";
import { useSelector } from "react-redux";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";
import { withToggle } from "../withToggle";

const NewMembers = ({ qa }) => {
  const {
    newMembersNumber,
    newMembersLink,
    newMembersPercentChange,
    prevNewMembersNumber,
    prevNewMembersLink,
    tooltip
  } = useSelector((state) => state.membershipUnits.membershipUnits.totalNewMembers.newMembers);

  return (
    <>
      <div className="content__el">
        <DataDisplay
          label="New Members"
          type="number"
          value={newMembersNumber}
          url={newMembersLink}
          disableAnimation={qa}
          toolTipContent={tooltip}
          toolTipId="membershipUnitsNewMembers"
          changeProps={{
            changeValue: newMembersPercentChange,
            toolTip: "Percentage change from previous month",
            showBorder: true
          }}
        />
      </div>
      <PreviousNewMembers
        title="Previous New Members"
        commonProps={{
          toolTipContent: `Previous ${tooltip}`,
          toolTipId: "membershipUnitsPrevNewMembers"
        }}
        dataPointProps={{
          type: "number",
          value: prevNewMembersNumber,
          url: prevNewMembersLink,
          disableAnimation: qa
        }}
      />
    </>
  );
};

const PreviousNewMembers = withToggle(DataDisplay);

export default NewMembers;
